import { useState, createContext } from "react";
import { VIEW_TYPE, SPORT_TYPE } from "constants/index";
import moment from "moment";
export const AppContext = createContext(null);

const AppContextProvider = ({ children }) => {
  const [pageBreadcrumb, setPageBreadcrumb] = useState("");
  const [appLoader, setAppLoader] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [pageView, setPageView] = useState(VIEW_TYPE.Week);
  const [sportView, setSportView] = useState(SPORT_TYPE.Run);
  const [dateRange, setDateRange] = useState({startDate: moment().startOf('isoWeek'), endDate: moment().endOf('isoWeek')});
  const [searchParams, setSearchParams] = useState(null);
  const [callSearch, setCallSearch] = useState(null);
  const [isOwner, setIsOwner] = useState(false);

  const state = {
    pageBreadcrumb,
    setPageBreadcrumb,
    appLoader,
    setAppLoader,
    selectedNote,
    setSelectedNote,
    selectedAthlete,
    setSelectedAthlete,
    pageView,
    setPageView,
    sportView,
    setSportView,
    dateRange,
    setDateRange,
    searchParams,
    setSearchParams,
    callSearch,
    setCallSearch,
    isOwner,
    setIsOwner,
  };
  return <AppContext.Provider value={state}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
